export default {
  translations: {
    // Mesmo valor usado nas configurações (defaultNS)
    webcast: {
      invite: {
        title: `Invitar`,
        button: `Invitar`,
      },
    },
  },
};
